import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { formatPhoneNumber } from "@covertree/utils";

import { RelationshipToInsured } from "@api/operations.generated";
import { SummaryStepHistory } from "@routing/paths";
import { ClaimSummaryBox } from "@routing/routes/ClaimSummary/types";
import { mapRelationshipToInsured } from "@utils/mapRelationshipToInsured";

export type ReportingPartyInput = {
  firstName: string;
  lastName: string;
  relationshipToInsured: RelationshipToInsured;
  phoneNumber: string;
};

const initialState: ReportingPartyInput = {
  firstName: "",
  lastName: "",
  relationshipToInsured: undefined,
  phoneNumber: "",
};

const claimReporterSlice = createSlice({
  name: "claimReporter",
  initialState,
  selectors: {
    selectClaimReporter: (state): ReportingPartyInput => state,
    selectClaimReporterSummary: (state): ClaimSummaryBox => ({
      boxTitle: "Who's reporting the claim?",
      navigate: SummaryStepHistory.CLAIM_REPORTER,
      items: [
        {
          value: state.firstName,
          label: "First Name",
          fullWidth: false,
        },
        {
          value: state.lastName,
          label: "Last Name",
          fullWidth: false,
        },
        {
          value: mapRelationshipToInsured(state.relationshipToInsured),
          label: "Relationship to insured",
          fullWidth: false,
        },
        {
          value: formatPhoneNumber(state.phoneNumber),
          label: "Phone number",
          fullWidth: false,
        },
      ].filter((el) => el.value),
    }),
  },
  reducers: {
    submitClaimReporterForm: (
      _state,
      { payload }: PayloadAction<ReportingPartyInput>
    ) => {
      return payload;
    },
    resetClaimReporter: () => initialState,
  },
});
export const {
  actions: { submitClaimReporterForm, resetClaimReporter },
  selectors: { selectClaimReporter, selectClaimReporterSummary },
} = claimReporterSlice;
export { initialState as claimReporterInitialState };
export default claimReporterSlice;
